import { OptionButton } from "@/react/components/OptionButton";
import { useSimpleKitContext, routes } from "@/react/context/SimpleKitContext";
import { useAccount, useSolanaWallet } from "@/react/hooks";
import { NetworkSymbols } from "based-auth/networks";
import { useEffect } from "react";

export function SelectSolanaWallet() {
  const { solWallets } = useSolanaWallet();
  const { users } = useAccount();
  const { setPendingItem, setRouter } = useSimpleKitContext();

  useEffect(() => {
    setPendingItem(null);
  }, []);

  return (
    <div className="web3kit-space-y-2">
      {solWallets
        .filter(
          (wallet) =>
            !users.find(
              (user) =>
                user.provider === wallet.name &&
                user.network === NetworkSymbols.sol
            )
        )
        .map((wallet: any, index: number) => (
          <OptionButton
            key={index}
            index={index}
            logo={wallet.icon}
            onClick={() => {
              setRouter(() => {
                setPendingItem({
                  id: wallet.name,
                  logo: wallet.icon,
                  network: NetworkSymbols.sol,
                  description: `Open the ${wallet.name} browser extension to connect your wallet.`,
                });
                return routes.walletConnecting;
              });
            }}
          >
            {wallet.name}
          </OptionButton>
        ))}
    </div>
  );
}
